// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tIHw","left":"styles_left__3Yyib","desktopActions":"styles_desktopActions__3kHEu","title":"styles_title__2E-jP"};